export default __webpack_public_path__ + "static/media/map-blank.c0a873e4.jpg";